/* eslint no-class-assign:off */
import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../actions';
import { getPeople, getIsPeopleFetching } from '../reducers';
import Loading from '../components/Loading';
import PeopleList from '../components/people/PeopleList';
import SectionHeader from '../components/SectionHeader';

class People extends Component {
  componentDidMount() {
    this.fetchData();
    document.querySelector('.main-wrapper').classList.add('on-full');
  }
  componentDidUpdate(prevProps) {
    const { edition } = this.props;
    if (edition !== prevProps.edition) {
      this.fetchData();
    }
  }
  componentWillUnmount() { // eslint-disable-line
    document.querySelector('.main-wrapper').classList.remove('on-full');
  }
  fetchData() {
    const { edition, fetchPeople } = this.props;
    fetchPeople(edition);
  }
  render() {
    const { lang, isFetching, people, edition, params, children } = this.props;
    const { team, participants, facilitators } = people;
    const nested = React.Children.map(children, child =>
      React.cloneElement(child, {
        edition,
      }),
    );
    if (isFetching && !team) {
      return (
        <div className={`${this.front ? 'is-front' : 'inner'} ${this.foldClass} main-wrapper`}>
          <Loading />
        </div>
      );
    }
    if (params.id) {
      return <div>{nested}</div>;
    }
    return (
      <div className="fold fold--people fold--main fold--main--full">
        <div className="fold--main__inner">
          <section className="fold__col fold__col--main">
            <SectionHeader lang={lang} title="people" />
            <div className="fold__col__body">
              <PeopleList
                lang={lang}
                type="team"
                people={team}
                edition={edition}
              />
              <PeopleList
                lang={lang}
                type="facilitators"
                edition={edition}
                people={facilitators}
              />
              <PeopleList
                lang={lang}
                type="participants"
                edition={edition}
                people={participants}
              />
            </div>
          </section>
        </div>
      </div>
    );
  }
}

People.propTypes = {
  lang: PropTypes.string.isRequired,
  params: PropTypes.objectOf(PropTypes.string).isRequired,
  fetchPeople: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
  edition: PropTypes.shape({
    background: PropTypes.string,
    backgroundTextColor: PropTypes.string,
    id: PropTypes.string,
    year: PropTypes.string,
  }).isRequired,
  people: PropTypes.shape({
    team: PropTypes.arrayOf(PropTypes.object),
    facilitators: PropTypes.arrayOf(PropTypes.object),
    participants: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  children: PropTypes.node,
};

People.defaultProps = {
  children: undefined,
};

const mapStateToProps = (state, ownProps) => {
  const { edition } = ownProps;
  return {
    people: getPeople(state, edition),
    isFetching: getIsPeopleFetching(state),
    edition,
  };
};

People = connect(
  mapStateToProps,
  actions,
)(People);

export default People;



// WEBPACK FOOTER //
// ./js/containers/People.js